import { render, staticRenderFns } from "./HomeReviewTile.vue?vue&type=template&id=0ea64dbb&scoped=true"
import script from "./HomeReviewTile.vue?vue&type=script&lang=js"
export * from "./HomeReviewTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea64dbb",
  null
  
)

export default component.exports